// extracted by mini-css-extract-plugin
module.exports = {"OSDToolbar":"btf","PDFToolbar":"bth","icon":"bti","active":"btj","withSpacer":"btk","roundedUp":"btl","withBadge":"btm"};